var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { BImg, BOverlay, BCarousel, BCarouselSlide, BModal, BButtonClose } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import { getVisualisationUrl } from 'ts/modules/frameDesigner';
let FrameVisualisation = class FrameVisualisation extends Vue {
    sku;
    uploadedImageName;
    artworkDimensions;
    rebateDimensions;
    mount;
    backing;
    chevronImages;
    frameErrors;
    vizImage;
    carouselHeight = 500;
    slideIndex = 0;
    slideInterval = 5000;
    timeout = null;
    loading = false;
    error = false;
    url = '#';
    get apertureSize() {
        return {
            width: this.artworkDimensions.width - 6,
            length: this.artworkDimensions.length - 6
        };
    }
    debouncedUpdateUrl = debounce(this.updateUrl, 250);
    updateUrl() {
        this.loading = true;
        this.slideIndex = 0;
        this.slideInterval = 0;
        let newUrl = getVisualisationUrl(this.sku, this.rebateDimensions, this.apertureSize, this.mount, this.backing, this.uploadedImageName);
        if (newUrl != this.url) {
            this.error = false;
            this.url = newUrl;
        }
        else {
            this.loading = false;
        }
    }
    openModal() {
        this.$bvModal.show('image-viewer');
    }
    closeModal() {
        this.$bvModal.hide('image-viewer');
    }
    mounted() {
        this.vizImage.addEventListener('error', () => {
            this.error = true;
            this.loading = false;
        });
        this.updateUrl();
    }
};
__decorate([
    Prop({ type: String, default: null })
], FrameVisualisation.prototype, "sku", void 0);
__decorate([
    Prop({ type: String, default: null })
], FrameVisualisation.prototype, "uploadedImageName", void 0);
__decorate([
    Prop(Object)
], FrameVisualisation.prototype, "artworkDimensions", void 0);
__decorate([
    Prop(Object)
], FrameVisualisation.prototype, "rebateDimensions", void 0);
__decorate([
    Prop(Object)
], FrameVisualisation.prototype, "mount", void 0);
__decorate([
    Prop(Boolean)
], FrameVisualisation.prototype, "backing", void 0);
__decorate([
    Prop({ type: Object, default: null })
], FrameVisualisation.prototype, "chevronImages", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], FrameVisualisation.prototype, "frameErrors", void 0);
__decorate([
    Ref('viz')
], FrameVisualisation.prototype, "vizImage", void 0);
__decorate([
    Watch('sku'),
    Watch('uploadedImageName'),
    Watch('artworkDimensions', { deep: true }),
    Watch('rebateDimensions', { deep: true }),
    Watch('mount', { deep: true }),
    Watch('backing')
], FrameVisualisation.prototype, "debouncedUpdateUrl", void 0);
FrameVisualisation = __decorate([
    Component({
        components: {
            BImg, BOverlay, BCarousel, BCarouselSlide, BModal, BButtonClose,
            TabHeading
        }
    })
], FrameVisualisation);
export default FrameVisualisation;
